import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showCommentBox: {},
  showDeleteConfirm: {
    isOpen: false,
    itemId: null,
    itemType: null,
    parentId: null,
  },
  // ID of the post whose SolutionDisplay is open; ensures only one is visible across the feed
  openSolutionsPostId: null,
  isLoading: false,
  isSidebarOpen: false,
  currentPath: "/",
  scrollEnabled: true,
  searchQuery: "",
  searchResults: [],
  isSearching: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleCommentBox: (state, action) => {
      const postId = action.payload;
      state.showCommentBox[postId] = !state.showCommentBox[postId];
    },
    openDeleteConfirm: (state, action) => {
      state.showDeleteConfirm = {
        isOpen: true,
        itemId: action.payload?.itemId || null,
        itemType: action.payload?.itemType || "post",
        parentId: action.payload?.parentId || null,
        postId: action.payload?.postId || null,
      };
    },
    closeDeleteConfirm: (state) => {
      state.showDeleteConfirm = {
        isOpen: false,
        itemId: null,
        itemType: null,
        parentId: null,
        postId: null,
      };
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    closeSidebarOnMobile: (state) => {
      if (window.innerWidth <= 768) {
        state.isSidebarOpen = false;
      }
    },
    setCurrentPath: (state, action) => {
      state.currentPath = action.payload;
    },
    disableScrolling: (state) => {
      state.scrollEnabled = false;
    },
    enableScrolling: (state) => {
      state.scrollEnabled = true;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    setSearching: (state, action) => {
      state.isSearching = action.payload;
    },
    // Set the globally open SolutionDisplay post id (null to close all)
    setOpenSolutionsPostId: (state, action) => {
      state.openSolutionsPostId = action.payload || null;
    },
    // Reset transient UI state that should not survive navigation (N1/XB2 fix)
    resetTransientUiState: (state) => {
      state.openSolutionsPostId = null;
      // Add any other transient state here that should reset on route change
    },
  },
});

export const {
  toggleCommentBox,
  openDeleteConfirm,
  closeDeleteConfirm,
  setLoading,
  toggleSidebar,
  closeSidebarOnMobile,
  setCurrentPath,
  disableScrolling,
  enableScrolling,
  setSearchQuery,
  setSearchResults,
  setSearching,
  setOpenSolutionsPostId,
  resetTransientUiState,
} = uiSlice.actions;

export default uiSlice.reducer;
